<template>
  <el-dialog :title="!id ? '发布' : '编辑' + title" :visible.sync="show" :append-to-body="true" :close-on-click-modal="false" class="dialog-medium">
    <!-- 内容区域 -->
    <FormView ref="vForm" :labels="fromLabels"></FormView>
    <span slot="footer">
      <el-button plain @click="show = false">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="btnloadSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formTaskManage } from '@/configs/forms'
export default {
  data() {
    return {
      btnloadSubmit: false,
      id: null,
      show: false,
      title: '任务',
      fromLabels: formTaskManage,
      detail: {}
    }
  },
  methods: {
    // 数据清空
    clear() {
      this.id = null
      this.detail = { taskMinAmount: 0, taskMaxAmount: 1 }
    },
    open(obj) {
      this.clear()
      if (obj && obj.id) {
        // 编辑
        const { id, taskName, taskDescribe, taskNumber } = obj
        this.id = obj.id
        this.detail = { id, taskName, taskDescribe, taskNumber, taskMinAmount: 0, taskMaxAmount: 1 }
      } else {
        // 添加
      }
      this.show = true
      this.$nextTick(() => {
        this.$refs.vForm.fillData(this.detail)
      })
    },
    // 提交
    async submit() {
      // 结果更新
      const params = await this.$refs.vForm.getForm()
      this.btnloadSubmit = true
      const res = await this.$api.EditTaskManage(params).finally(() => {
        this.btnloadSubmit = false
      })
      if (this.id) {
        // 编辑
        this.$message.success('编辑成功')
      } else {
        // 添加
        this.$message.success('发布成功')
      }
      this.$emit('submit')
      this.show = false
    }
  }
}
</script>
